/**
 * Static filter options for Sales Report
 */

export const PERIOD_OPTIONS = [
    { id: 'this_month', name: 'This Month' },
    { id: 'last_month', name: 'Last Month' },
    { id: 'this_quarter', name: 'This Quarter' },
    { id: 'last_quarter', name: 'Last Quarter' },
    { id: 'this_year', name: 'This Year' },
    { id: 'last_year', name: 'Last Year' },
    { id: 'custom', name: 'Custom Range' }
];

export const PAYMENT_OPTIONS = [
    { id: 'paid', name: 'Paid' },
    { id: 'partial', name: 'Partial' },
    { id: 'unpaid', name: 'Unpaid' }
];

export const STATUS_OPTIONS = [
    { id: 'lunas', name: 'Lunas' },
    { id: 'pembayaran_partial', name: 'Pembayaran Partial' },
    { id: 'belum_dibayar', name: 'Belum Dibayar' }
];

export const SERVICE_CATEGORY_OPTIONS = [
    { id: 'certificate_phase', name: 'Certificate Phase', value: 'certificate_phase' },
    { id: 'it_audit', name: 'IT Audit', value: 'it_audit' },
    { id: 'sustainability', name: 'Sustainability', value: 'sustainability' },
    { id: 'training_program', name: 'Training Program', value: 'training_program' }
];

export const SERVICE_TYPE_OPTIONS = [
    { id: 'all', name: 'All', value: 'all' },
    { id: 'activity', name: 'Activity', value: 'activity' },
    { id: 'administration', name: 'Administration', value: 'administration' }
];

